<script>
    import { createFilterItem } from '@/api/filters.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_FILTER_ITEM_ADD},
        },
        methods: {
            async create() {
                const data = this.$store.getters.FILTER_ITEM_DATA_ADD;
                const response = await createFilterItem(data);
                if (response != null) {
                    const filter = this.$store.getters.FILTER_BY_ID(
                        data.asset_type_id, 
                        Number(data.filter_id)
                    );
                    filter.filter_items.push(response);
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_FILTER_ITEM_ADD', false);
            }
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        class="button_blue_100"
        @click="create"
    >Create</button>
    <button
        class="button_blue_100 close_button mr_10"
        @click="close"
    >Close</button>
</template>